import {useEffect, useContext} from 'react';
import Spinner from '../../Utils/Spinner';
import clienteAxios from '../../Utils/axios';
import TokenContext from '../../context/Token/TokenContext';

const ValidacionComponent = ({ history, location }) => {
  const tokenContext = useContext(TokenContext);
  const { Active_Token_F, Redirect_F, redirect_login } = tokenContext;

const ConsultaClaveUnica = async () => {
  var Parametros = new URLSearchParams(location.search) 
  const code = Parametros.get("code")
  const sessionForm = new FormData()
  sessionForm.append("sesionid", code)

  try {
    const tri = await clienteAxios.post("LoginValidateMDD/", sessionForm);
  
    const refresh = tri.data.refresh
    const token = tri.data.access
    
    const dataForm = new FormData()
    dataForm.append("refresh", refresh)
    
    const respuesta = await clienteAxios.post("token/refresh/", dataForm,
    {
      headers: {
        Authorization: "Bearer " + token,
        accept: "application/json",
      },
    });
    
    localStorage.setItem("token", respuesta.data.access)
    localStorage.setItem("refresh", respuesta.data.refresh)
    localStorage.setItem("code", code)
    Active_Token_F(code)
    Redirect_F(false)
    history.push('/formulario/')
    

    // window.location.href="http://reclamosdesa-apb.superdesalud.gob.cl/formulario/";
    // window.location.href="http://localhost:3000/formulario/";
  } catch (error) {
    console.log(error)
    // window.location.href="http://reclamosdesa-apb.superdesalud.gob.cl/";
    // window.location.href="http://localhost:3000/";
    
    history.push('/')
  }
}

  useEffect(() => {
    ConsultaClaveUnica()
  }, [])

  return (  
      <Spinner/>
  );
}
 
export default ValidacionComponent;